import React from 'react'

import { Icon, getPaymentProviderIconByName } from '@fourthwall/components'
import { PaymentPlaceholderIcon } from '@fourthwall/icons'

type CreditCardIconProps = {
  brand: string
  size?: number
}

export const CreditCardIcon = ({ brand, size = 32 }: CreditCardIconProps) => {
  const icon = getPaymentProviderIconByName(brand) || PaymentPlaceholderIcon

  return <Icon component={icon} height={size} />
}
